import { fromEntries } from "~/tools/from-entries";
import { isArray } from "~/tools/is-array";
import { isEmpty } from "~/tools/is-empty";
import { isPlainObject } from "~/tools/is-plain-object";
import type { Record } from "~/tools/record";
import { toEntries } from "~/tools/to-entries";

function traverse(path: null | string, input: unknown): ReadonlyArray<[string, unknown]> {
	if (isPlainObject(input)) {
		if (isEmpty(input)) {
			return [];
		}

		return toEntries(input).flatMap(([key, value]) => traverse(path == null ? key : `${path}.${key}`, value));
	}

	if (isArray(input) && !isEmpty(input)) {
		return input.flatMap((value, index) => traverse(`${path ?? ""}[${index}]`, value));
	}

	if (path == null) {
		return [];
	}

	return [[path, input]];
}

export function flatObjectDeep(input: Record<string>): Record<string> {
	return fromEntries(traverse(null, input));
}
